import type { ContentHref, Version } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { openAside } from '@newStore/documentUI/documentUIState';
import type { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getVersionsForContent } from './versionsDataAccess';
import { loadVersions, setVersions } from './versionsState';

// Saga to handle loading versions
function* handleLoadVersions(action: PayloadAction<ContentHref>) {
  try {
    const loadVersion = yield select(
      (state: RootState) => state.versions[action.payload]?.isLoading === true,
    );
    if (!loadVersion) {
      return;
    }
    const versions: Version[] = yield call(getVersionsForContent, action.payload);
    yield put(setVersions({ href: action.payload, versions }));
  } catch (error) {
    console.error('Failed to load versions', error);
    // Handle error appropriately, e.g., dispatch an error action
  }
}

// Saga to handle opening the aside.
function* handleOpenAside(action: PayloadAction<{ href: ContentHref }>) {
  yield put(loadVersions(action.payload.href));
}

// Watcher saga to watch for loadVersions action
export function* watchLoadVersions() {
  yield takeLatest(loadVersions.type, handleLoadVersions);
  yield takeLatest(openAside, handleOpenAside);
}
